










































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Icon } from 'vant';
import lazyLoad from 'vue-lazyload';
Vue.use(Icon);
@Component
export default class ListItem extends Vue {
  @Prop() data!: any;
}
